import React, { useState, useEffect } from 'react';
import { formatMoneda } from '../../../util/varios';
import { TableBody, TableRow, TableCell, InputAdornment } from '@mui/material'

;

import useTableFijo from "../../useTableFijo"
import moment from 'moment';

const TablaMultasInmuebles = props => {
    const [titulo, setTitulo] = useState();
    const [msg, setMsg] = useState();
    const [mostrar, setMostrar] = useState(false);
    const [mostrar3, setMostrar3] = useState(false);
    const [mostrar4, setMostrar4] = useState(false);
    const [contar, setContar] = useState(0);
    const [contar3, setContar3] = useState(0);
    const [activate, setActivate] = useState(false);

    let op = require('../../../../src/modulos/datos');

    const headCells = [
        { id: 'idmulta', label: 'ID', width: '10px', textAlign: "center",backgroundColor: 'rgba(5, 81, 130, 1)',fontSize: "10px", color: "white", disableSorting: true },
        { id: 'fechamulta', label: 'FECHA', width: '80px', textAlign: "center",backgroundColor: 'rgba(5, 81, 130, 1)',fontSize: "10px", color: "white", disableSorting: true },
        { id: 'descripcion', label: 'TIPO MULTA', width: '150px', textAlign: "center",backgroundColor: 'rgba(5, 81, 130, 1)',fontSize: "10px", color: "white", disableSorting: true },
        { id: 'concepto', label: 'CONCEPTO', width: '150px', textAlign: "center",backgroundColor: 'rgba(5, 81, 130, 1)',fontSize: "10px", color: "white", disableSorting: true },
        { id: 'monto', label: 'MONTO', width: '150px', textAlign: "center",backgroundColor: 'rgba(5, 81, 130, 1)',fontSize: "10px", color: "white", disableSorting: true },
        { id: 'cancelada', label: 'PAGADA', width: '150px', textAlign: "center",backgroundColor: 'rgba(5, 81, 130, 1)',fontSize: "10px", color: "white", disableSorting: true },
    ]

    const [records, setRecords] = useState([]);

    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })

    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTableFijo(records, headCells, filterFn, 320);


    useEffect(() => {

        if (props.tabmulta) {
            setRecords(props.tabmulta);
        }

    }, [props.tabmulta]);



    return (
        <div>
            <div className="card-body">
                <div className="content" >
                    <div className="container">

                        <div className="row">

                            <div className="col-md-12 mx-auto"  style={{ margin: "auto" }} >
                            <TblContainer container={{ height: 250, width: '100%', overflow: 'auto', padding: '2px' }} >

                                    <TblHead />

                                    <tbody>
                                        {

                                            records && records.map((item, index) => (
                                                <tr key={item.idmulta} style={{ padding: "0" }}>
                                                    <td style={{ fontSize: "10px", textAlign: "center" }}>{item.idmulta}</td>
                                                    <td style={{ fontSize: "10px", textAlign: "center" }}>{moment.utc(item.fechamulta).format('DD/MM/YYYY')}</td>
                                                    <td style={{ fontSize: "10px", textAlign: "left" }}>{item.descripcion.trim()}</td>
                                                    <td style={{ fontSize: "10px", textAlign: "left" }}>{item.concepto.trim()}</td>
                                                    <td style={{ fontSize: "10px", textAlign: "right" }}>{formatMoneda(item.monto.toString().replace('.', ','), ',', '.', 2)}</td>
                                                    <td style={{ fontSize: "10px", textAlign: "center" }}>{item.cancelada ? 'SI' : 'NO'}</td>
                                                </tr>

                                            ))
                                        }
                                    </tbody>

                                </TblContainer>
                                {/*<TblPagination />*/}

                            </div>
                            <div align="center" className="col-md-12">
                                <a> &nbsp; </a>
                            </div>
                            {/*<div align="center" className="col-md-12">
                                <button style={{ marginBottom: "10px" }} onClick={imprimirDeuda('HisPago_IndCom')} className="btn btn-outline-primary"><i className="fas fa-print"> Imprimir </i> </button>
                            </div>*/}
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );

}

export default TablaMultasInmuebles;
